import e from "../../../helpers/service-helper.js";
import "react/jsx-runtime";
import "dayjs";
const a = async () => {
  const t = {
    "Content-Type": "application/json"
  };
  return e.httpGet("/v1/rentaltrailer/locations", { headers: t });
};
export {
  a as getTrailerRentalLocationsRequest
};
